var PauseNotificationsInterval;
(function (PauseNotificationsInterval) {
    PauseNotificationsInterval[PauseNotificationsInterval["FIFTEEN_MIN"] = 15] = "FIFTEEN_MIN";
    PauseNotificationsInterval[PauseNotificationsInterval["THIRTY_MIN"] = 30] = "THIRTY_MIN";
    PauseNotificationsInterval[PauseNotificationsInterval["ONE_HOUR"] = 60] = "ONE_HOUR";
})(PauseNotificationsInterval || (PauseNotificationsInterval = {}));
export default PauseNotificationsInterval;
